/** Converts a 2-letter ISO country code to the corresponding flag emoji. */
function countryFlag(code: string): string {
  return code
    .toUpperCase()
    .split('')
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join('')
}

interface Props {
  ip: string | null
  country: string | null
  city: string | null
}

export function GeoCell({ ip, country, city }: Props) {
  if (!ip) return <span className="dim">-</span>

  const flag = country && /^[A-Z]{2}$/.test(country.toUpperCase()) ? countryFlag(country) : null
  const label = [city, country].filter(Boolean).join(', ')

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        {flag && <span style={{ fontSize: '1rem', lineHeight: 1 }}>{flag}</span>}
        {label ? (
          <span style={{ fontSize: '0.78rem', color: 'var(--text2)' }}>{label}</span>
        ) : (
          <span style={{ fontFamily: 'var(--mono)', fontSize: '0.72rem', color: 'var(--text3)' }}>{ip}</span>
        )}
      </div>
      {label && (
        <div style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', color: 'var(--text3)', marginTop: 1 }}>
          {ip}
        </div>
      )}
    </div>
  )
}
